import {
  getPublishStatus,
  getPublishInfo,
  getReviewPatient,
  getReviewPayment
} from '@/api'
import { Dialog, Notify } from 'vant'
import { useRouter } from 'vue-router'
import { getUrlParam, getUrlCallback } from '@/utils/url'
import { isWeChat } from '@/utils/wx'

export function nextStep(step = 'other') {

  // return
  const router = useRouter()
  const info = getPublishInfo().then(res => {
    if (res.state === 'review') {
        router.push({
          name: 'Step5',
          query: {
            uuid: res.uuid
          }
        })
        return res

    }
    if(res.state === 'reject'){
      router.push({
        name: 'Step3',
      })
      return res
    }
    console.log(res.step,'res',sessionStorage.getItem('step'));
    if(res.step===2 && !sessionStorage.getItem('step')){
      router.push({
        name: 'Step2'
      })
    }else if(res.step===3 && !sessionStorage.getItem('step')){
        router.push({
          name: 'Step3'
        })
    }else if(res.step===4 && !sessionStorage.getItem('step')){
      router.push({
        name: 'Step4'
      })
    }else if(res.step===0){
      getPublishStatus().then(res => {
        if (res.last_uuid) {
          Dialog.confirm({
            message: '您已有正在求助的项目',
            confirmButtonText: '查看',
            cancelButtonText: '重新发起',
            confirmButtonColor: '#FA4200'
          })
            .then(() => {
              router.push({
                name: 'Info',
                query: {
                  uuid: res.last_uuid
                }
              })
            })
            .catch(() => {
              // console.log('last_uuid cancel')
            })
        }
      })
    }
    sessionStorage.setItem('step',res.step)
    // if (
    //   res.patient_card === '' &&
    //   (res.state === 'none' || res.state === 'reject') &&
    //   parseInt(res.target_amount) > 0
    // ) {
    // //  && sessionStorage.getItem('step')!=='1'
    //   // console.log('Step2')
    //   router.push({
    //     name: 'Step2'
    //   })
    //   return res
    // } else if (
    //   res.patient_card !== '' &&
    //   parseInt(res.target_amount) > 0 &&
    //  ( (res.state === 'reject' && res.has_asset && res.title!=='')
    //   || (res.state === 'none' && !res.has_asset && res.title===''))
    // ) {
    //   // && sessionStorage.getItem('step')!=='2'
    //   // console.log('Step3===>')
    //   router.push({
    //     name: 'Step3'
    //   })
    //   return res
    // } else if (
    //   res.patient_card !== '' &&
    //   res.state === 'none' &&
    //   parseInt(res.target_amount) > 0 &&
    //   !res.has_asset && res.title!==''
    // ) {
    //   // && sessionStorage.getItem('step')!=='2'
    //   // console.log('Step4')
    //   router.push({
    //     name: 'Step4'
    //   })
    //   return res
    // }  else if (res.state === 'review') {
    //   // console.log('Step5')
    //   router.push({
    //     name: 'Step5',
    //     query: {
    //       uuid: res.uuid
    //     }
    //   })
    //   return res
    // } else if (step === 'init') {
    //   // console.log('next init')
    //   // || sessionStorage.getItem('step')==='1'
    //   getPublishStatus().then(res => {
    //     if (res.last_uuid) {
    //       Dialog.confirm({
    //         message: '您已有正在求助的项目',
    //         confirmButtonText: '查看',
    //         cancelButtonText: '重新发起',
    //         confirmButtonColor: '#FA4200'
    //       })
    //         .then(() => {
    //           router.push({
    //             name: 'Info',
    //             query: {
    //               uuid: res.last_uuid
    //             }
    //           })
    //         })
    //         .catch(() => {
    //           // console.log('last_uuid cancel')
    //         })
    //     }
    //   })
      // if(sessionStorage.getItem('step')==='1'){
      //   router.push({
      //     name: 'Initiate'
      //   })
      // }
    //   return res
    // } else {
      return res
    // }
  })
  return info
}

export function getWxCode(path) {
  if (sessionStorage.getItem('yc_token')) {
    return
  }
  if (!isWeChat()) {
    // const router = useRouter()
    // router.go(-1)
    window.history.back()
    Notify({ type: 'primary', message: '请在微信环境下使用' })
    return
  }
  const link = `${process.env.VUE_APP_BACKURL}/?callback=${encodeURIComponent(
    getUrlCallback('redirect', path)
  )}`
  debugger
  window.location.href = `http://open.weixin.qq.com/connect/oauth2/authorize?appid=${
    process.env.VUE_APP_APPID
  }&redirect_uri=${encodeURIComponent(
    link
  )}&response_type=code&scope=snsapi_userinfo#wechat_redirect`
}

export function getWxCodeByOauth(callbackUrl) {
  if (sessionStorage.getItem('yc_token')) {
    return
  }
  if (!isWeChat()) {
    if (localStorage.getItem('yc_token')) {
      return
    }
    const router = useRouter()
    // router.go(-1)
    // window.history.back()
    // Notify({ type: 'primary', message: '请在微信环境下使用' })
    router.push({
      path: '/phoneSign',
      query: {
        callback: encodeURIComponent(callbackUrl)
      }
    })
    return
  }
  const link = `${process.env.VUE_APP_BACKURL}?callback=${encodeURIComponent(
    callbackUrl
  )}`
  debugger
  window.location.href = `http://open.weixin.qq.com/connect/oauth2/authorize?appid=${
    process.env.VUE_APP_APPID
  }&redirect_uri=${encodeURIComponent(
    link
  )}&response_type=code&scope=snsapi_userinfo#wechat_redirect`
}

export function getReviewPatientInfo(uuid) {
  return getReviewPatient(uuid).then(res => {
    return res
  })
}

export function getReviewPaymentInfo(uuid) {
  return getReviewPayment(uuid).then(res => {
    return res
  })
}
